import request from "../../utils/request-axios";
import api from "../../utils/api"


//文档管理分页列表
export function getDocumentManagePage(params) {
  return request(`${api.getDocumentManagePage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//根据ID查询
export function queryDocumentManage(params) {
  return request(`${api.queryDocumentManage}${params}`, {
    loading: true,
    method: 'get',
  })
}

//查询分类
export function queryDocumentType(params) {
  return request(`${api.queryDocumentType}`, {
    loading: true,
    method: 'get',
  })
}

//编辑文档
export function editDocumentManagePage(params) {
  return request(`${api.editDocumentManagePage}`, {
    loading: true,
    method: 'put',
    data: params,
    promptMessage: "编辑文档成功!",
  })
}

//创建文档
export function addDocumentPage(params) {
  return request(`${api.addDocumentPage}`, {
    loading: true,
    method: 'post',
    data: params,
    promptMessage: "创建文档成功!",
  })
}

//停用文档
export function disabledDocumentPage(params) {
  return request(`${api.disabledDocumentPage}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "停用文档成功!",
  })
}

//发布文档
export function releaseDocumentPage(params) {
  return request(`${api.releaseDocumentPage}${params}`, {
    loading: true,
    method: 'put',
    promptMessage: "发布文档成功!",
  })
}

//删除文档
export function deleteDocumentPage(params) {
  return request(`${api.deleteDocumentPage}${params}`, {
    loading: true,
    method: 'delete',
    promptMessage: "删除文档成功!",
  })
}



// WEBPACK FOOTER //
// ./src/services/file/fileManage.js